import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import Files from 'react-files';
import { validateEmail, validatePhone } from '../utils/form-validator';

const {
  i18n: {
    __,
  },
} = wp;

/**
 * TipForm component.
 */
const TipForm = (props) => {
  const {
    siteKey,
    agreeText,
    callLetters,
    nonce,
  } = props;
  const fileInstructions = __('On a desktop computer? Hold “Ctrl" on PC or “command" on Mac to select multiple files. Up to 5 files will be accepted. Zip and all common image, video, and document formats are accepted. Any documents or images submitted could be used for broadcast or digital use.', 'nbc'); // eslint-disable-line max-len
  const [captchaSolved, setCaptchaSolved] = useState(false);
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState([]);
  const validEmail = validateEmail(email);
  const validPhone = validatePhone(phone);
  let numbersOnly = (phone.match(/\d/g) || []).join('');
  let newPhone = '';
  if ('' !== numbersOnly) {
    if ('1' !== numbersOnly.substring(0, 1)) {
      numbersOnly = `1${numbersOnly}`;
    }
    if (7 < numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)} (${numbersOnly.substring(1, 4)}) ${numbersOnly.substring(4, 7)}-${numbersOnly.substring(7, 11)}`; // eslint-disable-line max-len
    } else if (4 < numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)} (${numbersOnly.substring(1, 4)}) ${numbersOnly.substring(4, 7)}`; // eslint-disable-line max-len
    } else if (1 < numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)} (${numbersOnly.substring(1, 4)}`; // eslint-disable-line max-len
    } else if (1 === numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)}`;
    }
  }
  const valid = subject &&
    description &&
    firstName &&
    lastName &&
    validEmail &&
    validPhone &&
    files &&
    captchaSolved;

  function onSubmit(e) {
    if (! valid) {
      e.preventDefault();
      return false;
    }
    return true;
  }
  return (
    <form
      action=""
      encType="multipart/form-data"
      method="post"
      onSubmit={onSubmit}
    >
      <div className="nf-form-fields-required">
        <span className="ninja-forms-req-symbol">*</span>
        {__('Required Fields', 'nbc')}
      </div>
      <label htmlFor="subject">
        {__('Subject', 'nbc')}
        <span className="ninja-forms-req-symbol">*</span>
      </label>
      <input
        id="subject"
        name="15"
        placeholder={__('Use a short descriptive subject', 'nbc')}
        required="required"
        size="30"
        type="text"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <label htmlFor="description">
        {__('Describe your tip in detail', 'nbc')}
        <span className="ninja-forms-req-symbol">*</span>
      </label>
      <textarea
        cols="75"
        name="16"
        placeholder={__('Please type in complete sentences', 'nbc')}
        rows="4"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <div className="columns">
        <div className="column">
          <label htmlFor="first_name">
            {__('First name', 'nbc')}
            <span className="ninja-forms-req-symbol">*</span>
          </label>
          <input
            id="first_name"
            name="50"
            required="required"
            size="30"
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="column">
          <label htmlFor="last_name">
            {__('Last name', 'nbc')}
            <span className="ninja-forms-req-symbol">*</span>
          </label>
          <input
            id="last_name"
            name="51"
            required="required"
            size="30"
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
      </div>
      <div className="columns">
        <div className="column">
          <label htmlFor="email">
            {__('Email', 'nbc')}
            <span className="ninja-forms-req-symbol">*</span>
          </label>
          <input
            id="email"
            name="52"
            placeholder={__('ex: mailAdress@client.com', 'nbc')}
            required="required"
            size="30"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={(! validEmail && email) ? 'invalid' : ''}
          />
        </div>
        <div className="column">
          <label htmlFor="phone">
            {__('Phone number', 'nbc')}
            <span className="ninja-forms-req-symbol">*</span>
          </label>
          <input
            id="phone"
            name="53"
            placeholder={__('+1 (555)-555-5555)', 'nbc')}
            required="required"
            size="30"
            type="text"
            value={newPhone}
            onChange={(e) => setPhone(e.target.value)}
            className={(! validPhone && email) ? 'invalid' : ''}
          />
        </div>
      </div>
      <fieldset>

        <Files
          className="files-dropzone"
          name="17[]"
          onChange={setFiles}
          onError={setFileError}
          accepts={['audio/*', 'video/*', 'image/*', 'application/pdf', 'application/zip', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword']} // eslint-disable-line max-len
          multiple
          maxFiles={5}
          maxFileSize={10000000}
          minFileSize={0}
          clickable
        >
          <button className="inputfile_label" type="button">
            {__('Choose files to upload', 'nbc')}
            <span className="ninja-forms-req-symbol">*</span>
          </button>
        </Files>
        {fileError &&
          <p className="error">{(2 === fileError.code) ? __('File is too large', 'nbc') : fileError.message}</p> // eslint-disable-line max-len
        }
        <ul className="file_list">
          { 0 === files.length &&
            <li>{__('No file chosen', 'nbc')}</li>
          }
          {files.map((file) => (
            <li>{ file.name }</li>
          ))}
        </ul>

        <p>{fileInstructions}</p>

        <input type="hidden" name="22" value={callLetters} />
        <input type="hidden" name="45" value="online form" />
        <input type="hidden" name="file_db" value="iteam_mgmt_console" />
        <input type="hidden" name="tip_nonce" value={nonce} />
      </fieldset>
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={setCaptchaSolved}
        className="recaptcha-container"
      />
      <div className="agreetext">{agreeText}</div>
      <input
        type="submit"
        value={__('Submit', 'nbc')}
        disabled={! valid}
      />
    </form>
  );
};

export default TipForm;

TipForm.propTypes = {
  siteKey: PropTypes.string.isRequired,
  agreeText: PropTypes.string.isRequired,
  callLetters: PropTypes.string.isRequired,
  nonce: PropTypes.string.isRequired,
};
